export enum RegionsPermissions {
  Region = 'region',
}
